import md5 from 'md5'
import Cookies from 'js-cookie'
import axios from '@/plugins/axios'

export const rules = {
  email: [
    { required: true, trigger: 'blur', message: 'Email es requerido' },
    {
      validator: (rule, value, callback) => {
        // eslint-disable-next-line
        const testedValue = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)
        if (!testedValue) return callback(new Error('Email debe ser correcto'))
        callback()
      },
      trigger: 'blur'
    }
  ],
  password: [],
  profile: {
    name: [{ required: true, trigger: 'blur', message: 'Nombre es obligatorio' }],
    lastName: [{ required: true, trigger: 'blur', message: 'Apellido es obligatorio' }],
    docType: [{ required: true, trigger: 'blur', message: 'Tipo de Documento es Obligatorio' }],
    docNumber: [{ required: true, trigger: 'blur', message: 'Documento es Obligatorio' }],
    phone: [
      { required: true, trigger: 'blur', message: 'Teléfono es obligatorio' },
      { min: 10, trigger: 'blur', message: 'El teléfono debe tener al menos 10 caracteres' }
    ]
  }
}

export const types = {
  super: 'SUPER',
  agency: 'Agencia',
  adviser: 'Asesor | Minorista',
  'product-loader': 'Cargador de Producto',
  reseller: 'Revendedor'
}

export const fetch = async (query) => {
  const { data } = await axios.get(`/api/user?deleted=${query.deleted}`)
  return data
}

export const fetchAll = async (query) => {
  // TODO: SECURE THIS ROUTE IN BACK WITH SA
  const { data } = await axios.get(`/api/user/all?deleted=${query.deleted}`)
  return data
}

export const fetchUser = async (id) => {
  const { data } = await axios.get(`/api/user/${id}`)
  return data
}

export const create = async (body) => {
  try {
    const { data } = await axios.post(`/api/user/`, body)
    return data
  } catch (e) {
    return { error: true }
  }
}

export const update = async (id, body) => {
  try {
    const { data } = await axios.put(`/api/user/${id}`, body)
    return data
  } catch (e) {
    return { error: true }
  }
}

export const toggleStatus = async (user) => {
  try {
    const status = user.status === 'active' ? 'inactive' : 'active'
    console.log('newStatus', status, user.status)
    const { data } = await axios.put(`/api/user/${user._id}`, { status })
    return data
  } catch (e) {
    return { error: true }
  }
}

export const deleteOne = async (userId) => {
  try {
    const { data } = await axios.delete(`/api/user/${userId}`)
    return data
  } catch (e) {
    return { error: true }
  }
}

export const restoreOne = async (userId) => {
  return update(userId, { '_deleted.value': false, '_deleted.date': null, '_deleted.user': null })
}

export const logIn = async (payload) => {
  const body = {
    user: payload.email,
    password: md5(payload.password),
    remember_me: payload.rememberMe
  }

  try {
    const { data } = await axios.post('/api/user/login', body)

    Cookies.set('ad-kudenix-token', data.token)

    return data
  } catch (e) {
    return { error: true }
  }
}

export const requestPasswordReset = async (payload) => {
  const body = {
    email: payload.email
  }

  try {
    const { data } = await axios.post('/api/user/remember-password', body)

    return data
  } catch (e) {
    return { error: true }
  }
}

export const changePassword = async (payload) => {
  const body = {
    token: payload.token,
    password: md5(payload.password)
  }

  try {
    const { data } = await axios.post('/api/user/change-password', body)

    return data
  } catch (e) {
    return { error: true }
  }
}
